export const CallSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.2308 23.9998C18.1849 23.9998 16.7157 23.6216 14.5156 22.3926C11.8402 20.8926 9.77084 19.5078 7.10994 16.8543C4.54442 14.2909 3.29595 12.6313 1.54863 9.4523C-0.425348 5.86297 -0.0888504 3.98152 0.287298 3.1774C0.735247 2.21632 1.39645 1.64149 2.25109 1.07094C2.73652 0.75296 3.25023 0.480375 3.78569 0.256649C3.83927 0.233613 3.88911 0.211648 3.93358 0.191827C4.19881 0.072361 4.60068 -0.108177 5.10971 0.0846825C5.44942 0.212184 5.7527 0.47308 6.22744 0.941836C7.20103 1.90185 8.53148 4.03991 9.0223 5.08992C9.35183 5.79761 9.56991 6.26476 9.57045 6.78869C9.57045 7.40209 9.26181 7.87513 8.88727 8.38568C8.81708 8.48157 8.74742 8.57318 8.67991 8.66211C8.27214 9.19783 8.18266 9.35265 8.2416 9.62908C8.36109 10.1846 9.25217 11.8384 10.7166 13.2993C12.181 14.7602 13.7874 15.5949 14.3452 15.7138C14.6334 15.7754 14.7915 15.6822 15.3445 15.26C15.4238 15.1995 15.5052 15.1368 15.5904 15.0741C16.1616 14.6493 16.6128 14.3488 17.2118 14.3488H17.215C17.7364 14.3488 18.1827 14.5749 18.9222 14.9477C19.8867 15.4342 22.0894 16.7472 23.0555 17.7217C23.5254 18.1953 23.7875 18.4974 23.9155 18.8365C24.1084 19.3471 23.9268 19.7472 23.8084 20.0151C23.7885 20.0596 23.7666 20.1083 23.7435 20.1624C23.518 20.6968 23.2437 21.2094 22.9242 21.6935C22.3547 22.5453 21.7776 23.2048 20.8142 23.6532C20.3195 23.8871 19.778 24.0057 19.2308 23.9998Z"
        fill="black"
      />
    </svg>
  );
};

export const Mailsvg = () => {
  return (
    <svg
      width="26"
      height="19"
      viewBox="0 0 26 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 16.6219V18.4389H25.9353V16.6219L17.4202 10.7672L12.7401 14.3339L8.19009 10.7672L0 16.6219Z"
        fill="black"
      />
      <path d="M0 13.9976V4.23975L6.76008 9.35422L0 13.9976Z" fill="black" />
      <path
        d="M25.8699 4.23975L19.1748 9.48881L25.8699 14.1995V4.23975Z"
        fill="black"
      />
      <path
        d="M0.0644531 1.88428V0H25.9997V1.88428L12.9346 11.844L0.0644531 1.88428Z"
        fill="black"
      />
    </svg>
  );
};

export const GithubSvg = () => {
  return (
    <svg
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5009 0.000897087C6.49006 0.000897087 0 6.4304 0 14.3545C0 20.6996 4.15451 26.0778 9.91228 27.9751C10.64 28.1106 10.9029 27.6665 10.9029 27.2826C10.9029 26.9417 10.8947 26.0401 10.8893 24.8433C6.85349 25.7081 6.00338 22.9137 6.00338 22.9137C5.34268 21.2594 4.38924 20.8154 4.38924 20.8154C3.07691 19.9281 4.49347 19.947 4.49347 19.947C5.94718 20.0448 6.71211 21.4227 6.71211 21.4227C8.00541 23.6188 10.1053 22.9837 10.9364 22.6141C11.0633 21.6891 11.4412 21.0531 11.8527 20.6988C8.63348 20.339 5.24842 19.1055 5.24842 13.6054C5.24842 12.0346 5.81033 10.7553 6.7393 9.75056C6.57888 9.39083 6.08766 7.92856 6.86709 5.95135C6.86709 5.95135 8.08063 5.56829 10.8548 7.42349C12.0158 7.10502 13.2484 6.94623 14.4801 6.93816C15.7126 6.94623 16.9443 7.10592 18.1053 7.42349C20.8632 5.56829 22.0758 5.95135 22.0758 5.95135C22.8543 7.92856 22.3631 9.38993 22.2217 9.75056C23.1416 10.7553 23.7035 12.0355 23.7035 13.6054C23.7035 19.1181 20.314 20.3336 17.0911 20.6844C17.595 21.1141 18.0672 21.9977 18.0672 23.3389C18.0672 25.2587 18.0491 26.8053 18.0491 27.2727C18.0491 27.6459 18.3029 28.0944 19.0497 27.95C24.85 26.0724 29 20.6898 29 14.3536C29 6.4295 22.5099 0 14.4991 0L14.5009 0.000897087Z"
        fill="black"
      />
    </svg>
  );
};

export const IntermediateIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1611_26"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        x="0"
        y="0"
        width="43"
        height="43"
      >
        <path
          d="M21.7969 2.70898L26.9977 6.3172L33.4361 6.3059L35.4132 12.1325L40.6289 15.7219L38.628 21.541L40.6289 27.3601L35.4132 30.9495L33.4361 36.7761L26.9977 36.7648L21.7969 40.373L16.5961 36.7648L10.1577 36.7761L8.18051 30.9495L2.96484 27.3601L4.96577 21.541L2.96484 15.7219L8.18051 12.1325L10.1577 6.3059L16.5961 6.3172L21.7969 2.70898Z"
          fill="white"
          stroke="white"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.8672 21.541L19.8175 26.249L29.7182 16.833"
          stroke="black"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </mask>
      <g mask="url(#mask0_1611_26)">
        <path
          d="M-1.96289 -1.05762H45.5602V44.1393H-1.96289V-1.05762Z"
          fill="url(#paint0_linear_1611_26)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1611_26"
          x1="21.7987"
          y1="-1.05762"
          x2="21.7987"
          y2="44.1393"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EC8A8A" />
          <stop offset="1" stop-color="#9C2B2B" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const IntermediateIconPlus = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 42 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1611_32"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="42"
        height="43"
      >
        <path
          d="M21.0762 2.70898L26.277 6.3172L32.7154 6.3059L34.6925 12.1325L39.9082 15.7219L37.9073 21.541L39.9082 27.3601L34.6925 30.9495L32.7154 36.7761L26.277 36.7648L21.0762 40.373L15.8754 36.7648L9.43697 36.7761L7.4598 30.9495L2.24414 27.3601L4.24506 21.541L2.24414 15.7219L7.4598 12.1325L9.43697 6.3059L15.8754 6.3172L21.0762 2.70898Z"
          fill="white"
          stroke="white"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.1465 21.541L19.0968 26.249L28.9975 16.833"
          stroke="black"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </mask>
      <g mask="url(#mask0_1611_32)">
        <path
          d="M-2.68359 -1.05762H44.8395V44.1393H-2.68359V-1.05762Z"
          fill="url(#paint0_linear_1611_32)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1611_32"
          x1="21.078"
          y1="-1.05762"
          x2="21.078"
          y2="44.1393"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A52121" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const BeginnerIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1611_14"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
        x="0"
        y="0"
        width="43"
        height="43"
      >
        <path
          d="M21.3262 2.70898L26.527 6.3172L32.9654 6.3059L34.9425 12.1325L40.1582 15.7219L38.1573 21.541L40.1582 27.3601L34.9425 30.9495L32.9654 36.7761L26.527 36.7648L21.3262 40.373L16.1254 36.7648L9.68697 36.7761L7.7098 30.9495L2.49414 27.3601L4.49506 21.541L2.49414 15.7219L7.7098 12.1325L9.68697 6.3059L16.1254 6.3172L21.3262 2.70898Z"
          fill="white"
          stroke="white"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.3965 21.541L19.3468 26.249L29.2475 16.833"
          stroke="black"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </mask>
      <g mask="url(#mask0_1611_14)">
        <path
          d="M-2.43359 -1.05762H45.0895V44.1393H-2.43359V-1.05762Z"
          fill="url(#paint0_linear_1611_14)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1611_14"
          x1="21.328"
          y1="-1.05762"
          x2="21.328"
          y2="44.1393"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C6FAB4" />
          <stop offset="1" stop-color="#307618" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const BeginnerIconPlus = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 42 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1611_20"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="42"
        height="43"
      >
        <path
          d="M20.8477 2.70898L26.0485 6.3172L32.4869 6.3059L34.464 12.1325L39.6797 15.7219L37.6788 21.541L39.6797 27.3601L34.464 30.9495L32.4869 36.7761L26.0485 36.7648L20.8477 40.373L15.6468 36.7648L9.20845 36.7761L7.23129 30.9495L2.01562 27.3601L4.01655 21.541L2.01562 15.7219L7.23129 12.1325L9.20845 6.3059L15.6468 6.3172L20.8477 2.70898Z"
          fill="white"
          stroke="white"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.918 21.541L18.8683 26.249L28.7689 16.833"
          stroke="black"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </mask>
      <g mask="url(#mask0_1611_20)">
        <path
          d="M-2.91211 -1.05762H44.611V44.1393H-2.91211V-1.05762Z"
          fill="url(#paint0_linear_1611_20)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1611_20"
          x1="20.8495"
          y1="-1.05762"
          x2="20.8495"
          y2="44.1393"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#54FD04" />
          <stop offset="1" stop-color="#45A817" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const EfforLevelIntermediate = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 35 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.5183 12.2539V33.2475H29.0587V16.9345C29.0587 16.6264 28.809 16.3763 28.5013 16.3763H26.962V15.7786L28.1615 16.2648C28.3688 16.3487 28.6063 16.3004 28.7646 16.1419L30.3991 14.505C30.5573 14.3464 30.6056 14.1087 30.5214 13.9005L29.8645 12.2767L29.8738 12.2539H34.5183ZM24.5048 17.7814C24.4176 17.9878 24.2153 18.1217 23.9914 18.1217H21.6819C21.458 18.1217 21.2561 17.9878 21.1685 17.7814L21.0462 17.4923H20.3851V18.6532H21.9244C22.232 18.6532 22.4818 18.9033 22.4818 19.2115V33.2475H27.9435V17.4923H24.6267L24.5048 17.7814ZM13.8111 21.5575H15.3504C15.6581 21.5575 15.9078 21.8076 15.9078 22.1157V33.2475H21.3674V19.7697H13.8111V21.5575ZM16.0131 8.20263C15.9399 7.82879 15.7474 7.52488 15.485 7.32694L15.8968 7.15231C16.0313 7.09509 16.1384 6.98743 16.1943 6.8518L16.9282 5.07753C16.984 4.94232 16.9849 4.79015 16.9299 4.65452L16.3259 3.15958L17.4365 2.04738L18.9292 2.65222C19.0646 2.70732 19.2166 2.70647 19.3516 2.65052L21.1232 1.91556C21.2582 1.85961 21.3661 1.75237 21.4233 1.61758L22.0513 0.132812H23.6223L24.2504 1.61758C24.3076 1.75237 24.4151 1.85961 24.5505 1.91556L26.3242 2.65052C26.4592 2.70647 26.6112 2.70732 26.7466 2.65222L28.2376 2.04738L29.3499 3.16L28.7459 4.65494C28.6909 4.79058 28.6918 4.94274 28.7476 5.07795L29.4815 6.85222C29.5374 6.98743 29.6445 7.09551 29.779 7.15273L31.2616 7.78174V9.35509L29.779 9.9841C29.6445 10.0413 29.5374 10.1494 29.4815 10.2846L28.9939 11.4642C28.9889 11.4752 28.9842 11.4867 28.98 11.4985L28.7476 12.061C28.6918 12.1962 28.6913 12.3484 28.7459 12.484L29.3499 13.9768L28.2372 15.0912L26.7445 14.4863C26.6091 14.4312 26.4571 14.4321 26.3221 14.488L24.5505 15.223C24.4155 15.2789 24.3076 15.3862 24.2504 15.5209L23.7798 16.634C23.7468 16.6857 23.7218 16.7433 23.7074 16.8052L23.6228 17.0057H22.0518L21.4237 15.5209C21.3665 15.3862 21.259 15.2789 21.1236 15.223L19.352 14.488C19.217 14.4321 19.065 14.4312 18.9296 14.4863L17.4369 15.0912L16.3259 13.9773L16.9299 12.484C16.9849 12.3484 16.984 12.1962 16.9282 12.061L16.1943 10.2846C16.1384 10.1494 16.0313 10.0413 15.8968 9.9841L15.3085 9.73445C15.8527 9.47844 16.1439 8.87105 16.0131 8.20263ZM18.098 8.56926C18.098 11.1866 20.2243 13.316 22.8377 13.316C25.4511 13.316 27.5774 11.1866 27.5774 8.56926C27.5774 5.95195 25.4511 3.82249 22.8377 3.82249C20.2243 3.82249 18.098 5.95195 18.098 8.56926ZM9.54158 10.1019L14.801 8.73626C14.9707 8.69218 14.9212 8.42812 14.9191 8.4171C14.9013 8.32597 14.8493 8.17635 14.7092 8.195L7.98749 9.09909C7.66118 9.14274 7.41613 9.34747 7.3154 9.66154L5.87643 14.1455L8.02135 14.8292L9.54158 10.1019ZM19.2127 8.56926C19.2127 6.56739 20.8392 4.9385 22.8381 4.9385C24.837 4.9385 26.4635 6.56739 26.4635 8.56926C26.4635 10.5711 24.837 12.2 22.8381 12.2C20.8392 12.2 19.2127 10.5711 19.2127 8.56926ZM20.6606 8.56926C20.6606 9.77047 21.6374 10.7475 22.8377 10.7475C24.038 10.7475 25.0127 9.77047 25.0127 8.56926C25.0127 7.36805 24.0371 6.38894 22.8377 6.38894C21.6383 6.38894 20.6606 7.36721 20.6606 8.56926ZM22.8377 9.63145C23.4226 9.63145 23.8983 9.15503 23.8983 8.56926C23.8983 7.98349 23.4226 7.50496 22.8377 7.50496C22.2528 7.50496 21.775 7.98222 21.775 8.56926C21.775 9.15631 22.2515 9.63145 22.8377 9.63145ZM9.6131 7.46215C10.5175 7.46215 11.2535 6.56103 11.2535 5.45391C11.2535 4.3468 10.5175 3.44568 9.6131 3.44568C8.70867 3.44568 7.97479 4.3468 7.97479 5.45391C7.97479 6.56103 8.70994 7.46215 9.6131 7.46215ZM6.69453 16.7552L9.51449 17.6551C9.65543 17.7 9.77308 17.7996 9.8408 17.9314C9.90852 18.0632 9.92121 18.2167 9.87593 18.3578L8.84706 21.5575H9.98131L11.0584 18.1472C11.1579 17.8301 11.1431 17.5584 11.0123 17.2935C10.8773 17.0231 10.6695 16.8451 10.3779 16.7514L5.59922 15.2281C5.59499 15.4858 5.65424 15.7414 5.77613 15.9766C5.96954 16.3509 6.29585 16.6272 6.69538 16.7548L6.69453 16.7552ZM7.23668 24.6712H8.77385C9.08153 24.6712 9.33124 24.9212 9.33124 25.2294V33.2475H14.793V22.674H7.23668V24.6712ZM6.06434 17.7059C5.64239 17.5152 5.28053 17.2215 5.00755 16.8485L2.49188 24.6712H3.49409L6.06434 17.7059ZM0.660156 33.2475H8.21646V25.7876H0.660156V33.2475Z"
        fill="url(#paint0_linear_1602_78)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1602_78"
          x1="17.5892"
          y1="0.132812"
          x2="17.5892"
          y2="33.2475"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" stop-color="#931715" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const EfforLevelIntermediatePlus = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3598 16.5394L14.4243 17.6394H16.8354L15.6325 14.9664L13.3598 13.2394L12.4709 10.6434L16.367 7.83285C16.6758 7.61285 16.8461 7.24985 16.8461 6.88685C16.8461 6.70535 16.8088 6.52385 16.7237 6.35885C16.4256 5.75385 15.6858 5.55035 15.1322 5.90785L3.64075 13.4099C3.30543 13.6299 3.11914 14.0039 3.11914 14.3889C3.11914 14.5649 3.16172 14.7409 3.24156 14.9114C3.5343 15.4999 4.24221 15.7144 4.79575 15.3844L8.16495 13.3769L8.6493 15.5164L7.57946 23.1394H9.78833L11.763 15.9894L13.3598 16.5394Z"
        fill="url(#paint0_linear_1604_254)"
      />
      <path
        d="M9.63395 23.6895H7.50491C7.21096 23.6895 6.97266 23.9357 6.97266 24.2395V30.2895C6.97266 30.5932 7.21096 30.8395 7.50491 30.8395H9.63395C9.9279 30.8395 10.1662 30.5932 10.1662 30.2895V24.2395C10.1662 23.9357 9.9279 23.6895 9.63395 23.6895Z"
        fill="url(#paint1_linear_1604_254)"
      />
      <path
        d="M24.5363 14.8887H22.4073C22.1133 14.8887 21.875 15.1349 21.875 15.4387V30.2887C21.875 30.5924 22.1133 30.8387 22.4073 30.8387H24.5363C24.8302 30.8387 25.0685 30.5924 25.0685 30.2887V15.4387C25.0685 15.1349 24.8302 14.8887 24.5363 14.8887Z"
        fill="url(#paint2_linear_1604_254)"
      />
      <path
        d="M3.24723 19.8389H1.1182C0.824238 19.8389 0.585938 20.0851 0.585938 20.3889V30.2889C0.585938 30.5926 0.824238 30.8389 1.1182 30.8389H3.24723C3.54119 30.8389 3.77949 30.5926 3.77949 30.2889V20.3889C3.77949 20.0851 3.54119 19.8389 3.24723 19.8389Z"
        fill="url(#paint3_linear_1604_254)"
      />
      <path
        d="M17.0851 18.1895H14.9561C14.6621 18.1895 14.4238 18.4357 14.4238 18.7395V30.2895C14.4238 30.5932 14.6621 30.8395 14.9561 30.8395H17.0851C17.3791 30.8395 17.6174 30.5932 17.6174 30.2895V18.7395C17.6174 18.4357 17.3791 18.1895 17.0851 18.1895Z"
        fill="url(#paint4_linear_1604_254)"
      />
      <path
        d="M31.9875 20.9395H29.8584C29.5645 20.9395 29.3262 21.1857 29.3262 21.4895V30.2895C29.3262 30.5932 29.5645 30.8395 29.8584 30.8395H31.9875C32.2814 30.8395 32.5197 30.5932 32.5197 30.2895V21.4895C32.5197 21.1857 32.2814 20.9395 31.9875 20.9395Z"
        fill="url(#paint5_linear_1604_254)"
      />
      <path
        d="M31.4563 7.73906V1.13906C31.4563 0.534062 30.9773 0.0390625 30.3918 0.0390625H21.8757C21.2902 0.0390625 20.8112 0.534062 20.8112 1.13906V2.73406C20.8112 2.76706 20.7952 2.80006 20.7686 2.82206L18.7939 4.35106C18.7354 4.39506 18.7354 4.48306 18.7939 4.52706L20.7686 6.05606C20.7952 6.07806 20.8112 6.11106 20.8112 6.14406V7.73906C20.8112 8.34406 21.2902 8.83906 21.8757 8.83906H30.3918C30.9773 8.83906 31.4563 8.34406 31.4563 7.73906ZM28.3905 4.01006L27.326 5.08256C27.326 5.08256 27.2888 5.14306 27.2941 5.18156L27.5442 6.69406C27.5602 6.78206 27.4697 6.85356 27.3899 6.80956L26.0752 6.09456C26.0433 6.07806 26.006 6.07806 25.9741 6.09456L24.6594 6.80956C24.5796 6.85356 24.4891 6.78206 24.505 6.69406L24.7552 5.18156C24.7605 5.14856 24.7499 5.11006 24.7233 5.08256L23.6587 4.01006C23.5949 3.94406 23.6321 3.83406 23.7173 3.82306L25.1863 3.60306C25.2236 3.60306 25.2502 3.57556 25.2662 3.54256L25.9262 2.16756C25.9634 2.08506 26.0805 2.08506 26.1178 2.16756L26.7778 3.54256C26.7937 3.57556 26.8257 3.59756 26.8576 3.60306L28.3267 3.82306C28.4118 3.83406 28.4491 3.94956 28.3852 4.01006H28.3905Z"
        fill="url(#paint6_linear_1604_254)"
      />
      <path
        d="M8.56943 9.38887C9.4513 9.38887 10.1662 8.65014 10.1662 7.73887C10.1662 6.8276 9.4513 6.08887 8.56943 6.08887C7.68756 6.08887 6.97266 6.8276 6.97266 7.73887C6.97266 8.65014 7.68756 9.38887 8.56943 9.38887Z"
        fill="url(#paint7_linear_1604_254)"
      />
      <path
        d="M32.5205 31.9395H0.584992C0.292251 31.9395 0.0527344 32.187 0.0527344 32.4895C0.0527344 32.792 0.292251 33.0395 0.584992 33.0395H32.5205C32.8132 33.0395 33.0527 32.792 33.0527 32.4895C33.0527 32.187 32.8132 31.9395 32.5205 31.9395Z"
        fill="url(#paint8_linear_1604_254)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1604_254"
          x1="9.98261"
          y1="5.73145"
          x2="9.98261"
          y2="23.1394"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1604_254"
          x1="8.56943"
          y1="23.6895"
          x2="8.56943"
          y2="30.8395"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1604_254"
          x1="23.4718"
          y1="14.8887"
          x2="23.4718"
          y2="30.8387"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1604_254"
          x1="2.18271"
          y1="19.8389"
          x2="2.18271"
          y2="30.8389"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1604_254"
          x1="16.0206"
          y1="18.1895"
          x2="16.0206"
          y2="30.8395"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1604_254"
          x1="30.9229"
          y1="20.9395"
          x2="30.9229"
          y2="30.8395"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1604_254"
          x1="25.1032"
          y1="0.0390625"
          x2="25.1032"
          y2="8.83906"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1604_254"
          x1="8.56943"
          y1="6.08887"
          x2="8.56943"
          y2="9.38887"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1604_254"
          x1="16.5527"
          y1="31.9395"
          x2="16.5527"
          y2="33.0395"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const EfforBeginner = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.71445 27.2877L8.26445 23.5037L9.91445 24.5817L12.6645 22.9592V21.6502L9.91445 22.4147L8.40195 20.9297C9.02345 20.6932 9.50195 20.1597 9.61195 19.4667C9.77695 18.4327 9.06195 17.4647 8.01145 17.3052C6.96095 17.1402 5.97645 17.8442 5.81145 18.8782C5.74545 19.3017 5.82795 19.7087 6.02045 20.0607L4.96445 19.7142L0.564453 22.9592L1.11445 24.5817L3.86445 22.9592L2.84695 28.0302L0.784453 29.5482C0.646953 29.6527 0.564453 29.8122 0.564453 29.9827V31.6052C0.564453 31.7922 0.663453 31.9682 0.822953 32.0672C0.910953 32.1222 1.00995 32.1497 1.11445 32.1497C1.19695 32.1497 1.28495 32.1332 1.36195 32.0947L4.66195 30.4722C4.73895 30.4337 4.80495 30.3787 4.85445 30.3127L6.09195 28.6957L7.16445 29.4492V31.6107L8.26445 32.6887L9.91445 28.9047L7.71445 27.2822V27.2877ZM4.05145 29.5647L1.66445 30.7362V30.2577L3.64445 28.8002C3.73245 28.7342 3.79845 28.6407 3.83695 28.5417L4.22745 27.3922L5.19545 28.0687L4.05145 29.5647Z"
        fill="url(#paint0_linear_1604_230)"
      />
      <path
        d="M17.0629 8.48926H15.9629V9.58926H17.0629V8.48926Z"
        fill="url(#paint1_linear_1604_230)"
      />
      <path
        d="M22.5629 14.5391H21.4629V15.6391H22.5629V14.5391Z"
        fill="url(#paint2_linear_1604_230)"
      />
      <path
        d="M11.5629 14.5391H10.4629V15.6391H11.5629V14.5391Z"
        fill="url(#paint3_linear_1604_230)"
      />
      <path
        d="M21.3755 10.2739L20.5977 11.0518L21.3755 11.8296L22.1533 11.0518L21.3755 10.2739Z"
        fill="url(#paint4_linear_1604_230)"
      />
      <path
        d="M11.6489 10.2749L10.8711 11.0527L11.6489 11.8306L12.4267 11.0527L11.6489 10.2749Z"
        fill="url(#paint5_linear_1604_230)"
      />
      <path
        d="M24.2129 10.8047V15.0892L27.5129 13.4392L30.8129 15.0892V10.8047C29.8614 11.4262 28.7284 11.7892 27.5129 11.7892C26.2974 11.7892 25.1644 11.4262 24.2129 10.8047Z"
        fill="url(#paint6_linear_1604_230)"
      />
      <path
        d="M16.5141 21.1395C17.7296 21.1395 18.7141 20.155 18.7141 18.9395V17.6965C19.7371 16.9815 20.3641 15.799 20.3641 14.5395C20.3641 12.4165 18.6371 10.6895 16.5141 10.6895C14.3911 10.6895 12.6641 12.4165 12.6641 14.5395C12.6641 15.799 13.2911 16.9815 14.3141 17.6965V18.9395C14.3141 20.155 15.2986 21.1395 16.5141 21.1395ZM16.5141 20.0395C15.9091 20.0395 15.4141 19.5445 15.4141 18.9395H17.6141C17.6141 19.5445 17.1191 20.0395 16.5141 20.0395ZM14.3746 14.292L14.9246 13.192C15.0621 12.9225 15.3921 12.807 15.6616 12.9445L16.5141 13.3735L17.3666 12.9445C17.6361 12.807 17.9661 12.917 18.1036 13.192L18.6536 14.292L17.6691 14.7815L17.3666 14.171L16.7561 14.4735C16.6021 14.5505 16.4206 14.5505 16.2666 14.4735L15.6561 14.171L15.5296 14.424L16.8991 15.7935C17.0036 15.898 17.0586 16.0355 17.0586 16.184V17.834H15.9586V16.4095L14.4681 14.919C14.3031 14.754 14.2591 14.4955 14.3636 14.2865L14.3746 14.292Z"
        fill="url(#paint7_linear_1604_230)"
      />
      <path
        d="M32.4645 5.73906C32.4645 3.01106 30.2425 0.789062 27.5145 0.789062C24.7865 0.789062 22.5645 3.01106 22.5645 5.73906C22.5645 8.46706 24.7865 10.6891 27.5145 10.6891C30.2425 10.6891 32.4645 8.46706 32.4645 5.73906ZM29.214 8.48906L27.5145 7.54856L25.815 8.48906L26.1395 6.49806L24.7645 5.09006L26.662 4.79856L27.5145 2.98906L28.367 4.79856L30.2645 5.09006L28.8895 6.49806L29.214 8.48906Z"
        fill="url(#paint8_linear_1604_230)"
      />
      <path
        d="M32.4637 16.1895H23.6637C22.7562 16.1895 22.0137 16.932 22.0137 17.8395V26.0895C22.0137 26.392 21.7662 26.6395 21.4637 26.6395H12.6637C11.7562 26.6395 11.0137 27.382 11.0137 28.2895V32.1395C11.0137 32.442 10.7662 32.6895 10.4637 32.6895H0.0136719V33.7895H32.4637C32.7662 33.7895 33.0137 33.542 33.0137 33.2395V16.7395C33.0137 16.437 32.7662 16.1895 32.4637 16.1895Z"
        fill="url(#paint9_linear_1604_230)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1604_230"
          x1="6.61445"
          y1="17.2812"
          x2="6.61445"
          y2="32.6887"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1604_230"
          x1="16.5129"
          y1="8.48926"
          x2="16.5129"
          y2="9.58926"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1604_230"
          x1="22.0129"
          y1="14.5391"
          x2="22.0129"
          y2="15.6391"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1604_230"
          x1="11.0129"
          y1="14.5391"
          x2="11.0129"
          y2="15.6391"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1604_230"
          x1="20.9866"
          y1="10.6628"
          x2="21.7644"
          y2="11.4407"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1604_230"
          x1="11.26"
          y1="10.6638"
          x2="12.0378"
          y2="11.4416"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1604_230"
          x1="27.5129"
          y1="10.8047"
          x2="27.5129"
          y2="15.0892"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1604_230"
          x1="16.5141"
          y1="10.6895"
          x2="16.5141"
          y2="21.1395"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1604_230"
          x1="27.5145"
          y1="0.789062"
          x2="27.5145"
          y2="10.6891"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_1604_230"
          x1="16.5137"
          y1="16.1895"
          x2="16.5137"
          y2="33.7895"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const EffortBeginnerPlus = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.4394 12.5116L28.3277 12.2002L28.221 12.5116C28.1702 12.651 28.0279 12.7486 27.8654 12.7486H27.5098L27.7993 12.9392C27.9263 13.0229 27.9822 13.1762 27.9314 13.325L27.8196 13.6271L28.1092 13.4412C28.2362 13.3482 28.4191 13.3482 28.5512 13.4412L28.8357 13.6271L28.7239 13.325C28.6731 13.1762 28.729 13.0229 28.8661 12.9392L29.1506 12.7486H28.795C28.6325 12.7486 28.4851 12.651 28.4394 12.5116Z"
        fill="url(#paint0_linear_1604_271)"
      />
      <path
        d="M33.2452 32.3346H31.8786V10.0712C31.8786 9.88063 31.7161 9.72725 31.5078 9.72725H25.4727C25.9045 8.85809 26.1534 7.90063 26.1534 6.88739C26.1534 3.10866 22.7904 0.0224609 18.6502 0.0224609C14.5099 0.0224609 11.147 3.10401 11.147 6.88739C11.147 8.33753 11.6448 9.68077 12.483 10.787C12.1731 10.615 11.8124 10.5127 11.4264 10.5127C10.3087 10.5127 9.39942 11.3447 9.39942 12.3672C9.39942 12.6322 9.46546 12.8785 9.57214 13.1063C9.52134 13.083 9.46546 13.0644 9.41466 13.0644H9.34862C9.05398 13.0644 8.06337 13.1202 7.45884 13.7849L4.99502 16.4156C4.9747 16.4295 4.95946 16.4527 4.9493 16.476C4.90358 16.555 3.86217 18.4002 4.01965 21.2308L1.75394 25.1815C1.74378 25.1908 1.7387 25.2047 1.73362 25.214C1.7133 25.2698 1.52534 25.7392 1.77935 26.1715C1.86571 26.3202 2.03843 26.5061 2.35339 26.6316V32.3392H0.991938C0.783656 32.3392 0.621094 32.4926 0.621094 32.6785C0.621094 32.8691 0.783656 33.0225 0.991938 33.0225H2.73439H9.0997H14.6115H20.1945H25.8486H31.5078H33.2452C33.4535 33.0225 33.6211 32.8691 33.6211 32.6785C33.6211 32.4926 33.4535 32.3346 33.2452 32.3346ZM30.5223 12.6787L29.5164 13.3433L29.8974 14.417C29.9482 14.5564 29.8923 14.7098 29.7653 14.7981C29.6993 14.8492 29.6231 14.8725 29.5418 14.8725C29.4656 14.8725 29.3894 14.8492 29.3234 14.8027L28.3226 14.1381L27.3269 14.8027C27.1948 14.8957 27.0119 14.8957 26.8849 14.8027C26.7529 14.7144 26.697 14.5611 26.7478 14.4216L27.1288 13.3433L26.128 12.6787C25.9959 12.5903 25.9401 12.437 25.9909 12.2975C26.0417 12.1581 26.1839 12.0605 26.3465 12.0605H27.586L27.967 10.9868C28.0178 10.8474 28.16 10.7498 28.3226 10.7498C28.4852 10.7498 28.6325 10.8474 28.6782 10.9868L29.0643 12.0605H30.2987C30.4613 12.0605 30.6086 12.1581 30.6543 12.2975C30.7001 12.437 30.6493 12.5903 30.5223 12.6787ZM19.1125 18.7116H13.8292C13.6209 18.7116 13.4533 18.865 13.4533 19.0556V22.6763H10.6491C10.6948 22.588 10.7304 22.4996 10.7558 22.3927L11.5788 19.8225C11.6194 19.7295 11.9445 18.9301 11.5788 18.3537C11.4619 18.1585 11.2028 17.9122 10.6999 17.8425L9.51118 17.6751L10.5323 16.7177L13.1129 16.8757C13.1942 16.8803 13.2653 16.8618 13.3365 16.8246L15.8968 15.407C15.9628 15.3744 16.5216 15.0723 16.6537 14.5703C16.7198 14.3287 16.6639 14.087 16.5166 13.8825C16.4912 13.8406 16.2575 13.4827 15.6733 13.4827C15.3837 13.4827 15.0688 13.5757 14.7335 13.743L12.8437 14.6215L11.3552 14.2218C11.3756 14.2218 11.401 14.2218 11.4264 14.2218C12.549 14.2218 13.4533 13.3898 13.4533 12.3719C13.4533 12.1395 13.4025 11.9164 13.3212 11.7165C14.6827 12.9715 16.5724 13.7523 18.6502 13.7523C18.8026 13.7523 18.9601 13.7384 19.1125 13.7291V18.7116ZM7.91604 22.8529C7.88556 22.904 7.86524 22.9551 7.86524 23.0202V26.2365H4.34985C4.37525 26.204 4.40065 26.1761 4.43113 26.1436L6.85431 22.2765C6.87971 22.244 6.89495 22.2022 6.90003 22.1696L7.34708 19.776L8.55105 19.9294C8.57645 19.934 8.73393 19.9758 8.78473 20.0549C8.83045 20.1339 8.77965 20.264 8.74409 20.343L7.89572 22.4299C7.88048 22.4532 7.8754 22.4811 7.87032 22.5089C7.86524 22.5461 7.85508 22.6902 7.91604 22.8529ZM24.7666 10.8474V13.3572H21.1343C22.6075 12.8832 23.8725 11.9954 24.7666 10.8474ZM14.2356 32.3346H9.47562V26.5851C9.47562 26.3946 9.30798 26.2412 9.0997 26.2412H8.61709V23.3642H8.81521C8.87109 23.3734 8.99301 23.3874 9.15558 23.3874C9.26734 23.3874 9.3791 23.3781 9.48578 23.3642H14.2356V32.3346ZM25.4778 32.3346H20.5704V19.0556C20.5704 18.865 20.4028 18.7116 20.1945 18.7116H19.8592V14.0451H25.4727L25.4778 32.3346Z"
        fill="url(#paint1_linear_1604_271)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1604_271"
          x1="28.3302"
          y1="12.2002"
          x2="28.3302"
          y2="13.6271"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1604_271"
          x1="17.1211"
          y1="0.0224609"
          x2="17.1211"
          y2="33.0225"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F62926" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const InformationIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.1027 29.3595L21.1617 26.4185L19.5781 28.0021L24.1027 32.5266L32.0206 24.6087L30.4371 23.0251L24.1027 29.3595ZM11.6602 18.953H20.7093V21.2153H11.6602V18.953ZM11.6602 13.2973H20.7093V15.5596H11.6602V13.2973ZM11.6602 7.6416H20.7093V9.90388H11.6602V7.6416Z"
        fill="url(#paint0_linear_1602_79)"
      />
      <path
        d="M16.1855 30.2641H4.87416V25.7395H7.13644V23.4773H4.87416V17.8216H7.13644V15.5593H4.87416V9.9036H7.13644V7.64132H4.87416V3.11677H25.2347V21.215H27.4969V3.11677C27.4969 1.87252 26.4789 0.854492 25.2347 0.854492H4.87416C3.62991 0.854492 2.61189 1.87252 2.61189 3.11677V7.64132H0.349609V9.9036H2.61189V15.5593H0.349609V17.8216H2.61189V23.4773H0.349609V25.7395H2.61189V30.2641C2.61189 31.5083 3.62991 32.5264 4.87416 32.5264H16.1855V30.2641Z"
        fill="url(#paint1_linear_1602_79)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1602_79"
          x1="21.8404"
          y1="7.6416"
          x2="21.8404"
          y2="32.5266"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B0B661" />
          <stop offset="1" stop-color="#181818" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1602_79"
          x1="13.9233"
          y1="0.854492"
          x2="13.9233"
          y2="32.5264"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B0B661" />
          <stop offset="1" stop-color="#181818" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const DailyIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 49 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.9824 0.562085C17.298 0.250141 17.7238 0.0751953 18.1676 0.0751953C18.6113 0.0751953 19.0372 0.250141 19.3528 0.562085L23.8197 4.99537C24.3 5.47088 24.4441 6.18654 24.1823 6.80615C24.0545 7.11082 23.8395 7.37094 23.5643 7.55382C23.2892 7.73669 22.9661 7.83417 22.6357 7.83402H18.1688C10.4526 7.83161 4.20129 14.0373 4.20129 21.6886C4.20129 29.34 10.4598 35.5456 18.1688 35.5456H19.2831C20.2101 35.5456 20.9594 36.2901 20.9594 37.2075C20.9585 37.4267 20.9143 37.6436 20.8296 37.8457C20.7448 38.0479 20.6211 38.2313 20.4654 38.3856C20.3098 38.54 20.1253 38.6621 19.9224 38.7451C19.7195 38.8281 19.5023 38.8704 19.2831 38.8694H18.1688C8.60576 38.8694 0.853516 31.1748 0.853516 21.6886C0.853516 12.2025 8.60576 4.50785 18.1688 4.50785H18.5891L16.9824 2.91321C16.8267 2.75932 16.7031 2.57607 16.6188 2.37407C16.5344 2.17208 16.491 1.95535 16.491 1.73645C16.491 1.51755 16.5344 1.30082 16.6188 1.09882C16.7031 0.896827 16.8267 0.713575 16.9824 0.559683M28.7789 6.16973C28.7789 5.25234 29.5282 4.50785 30.4552 4.50785H31.5719C41.1325 4.50785 48.8848 12.2025 48.8848 21.6886C48.8848 31.1748 41.1325 38.8694 31.5695 38.8694H31.1492L32.7559 40.464C32.9118 40.6178 33.0357 40.801 33.1202 41.003C33.2048 41.205 33.2483 41.4218 33.2483 41.6408C33.2483 41.8598 33.2048 42.0766 33.1202 42.2786C33.0357 42.4806 32.9118 42.6639 32.7559 42.8176C32.4406 43.1301 32.0146 43.3054 31.5707 43.3054C31.1268 43.3054 30.7008 43.1301 30.3855 42.8176L25.9186 38.3819C25.6848 38.1505 25.5253 37.8545 25.4607 37.5319C25.3961 37.2093 25.4293 36.8747 25.556 36.5711C25.6838 36.2664 25.8988 36.0063 26.174 35.8234C26.4491 35.6406 26.7722 35.5431 27.1026 35.5432H31.5695C39.2833 35.5432 45.5346 29.34 45.5346 21.6886C45.5346 14.0373 39.2833 7.83161 31.5719 7.83161H30.4552C30.236 7.83256 30.0188 7.79033 29.8159 7.70732C29.613 7.62432 29.4285 7.50217 29.2728 7.34785C29.1172 7.19353 28.9934 7.01006 28.9087 6.80792C28.8239 6.60578 28.7798 6.38892 28.7789 6.16973Z"
        fill="url(#paint0_linear_1602_73)"
      />
      <path
        d="M9.23047 21.6879C9.23047 16.7887 13.2315 12.8213 18.1667 12.8213H31.5722C36.5074 12.8213 40.506 16.7911 40.506 21.6879C40.506 26.587 36.5074 30.5544 31.5722 30.5544H18.1667C13.2315 30.5544 9.23047 26.5846 9.23047 21.6879Z"
        fill="url(#paint1_linear_1602_73)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1602_73"
          x1="24.8691"
          y1="0.0751953"
          x2="24.8691"
          y2="43.3054"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5D9908" />
          <stop offset="1" stop-color="#21FF44" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1602_73"
          x1="24.8682"
          y1="12.8213"
          x2="24.8682"
          y2="30.5544"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5D9908" />
          <stop offset="1" stop-color="#21FF44" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const OccasionalyIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9877 10.2812H11.7734V22.4598H13.9877V10.2812ZM20.6306 10.2812H18.4163V22.4598H20.6306V10.2812Z"
        fill="url(#paint0_linear_1603_167)"
      />
      <path
        d="M16.2031 0.316407C14.1377 0.315768 12.0932 0.730419 10.1913 1.53571C8.28933 2.341 6.5687 3.52049 5.1317 5.00405V0.316407H2.91741V9.17355H11.7746V6.95926H6.3252C8.39945 4.65579 11.2149 3.15142 14.2826 2.70733C17.3504 2.26324 20.4768 2.90746 23.1192 4.52816C25.7615 6.14886 27.7528 8.6437 28.7475 11.5795C29.7421 14.5154 29.6773 17.7068 28.5642 20.5999C27.4511 23.4929 25.3601 25.9048 22.6541 27.4168C19.9481 28.9288 16.7981 29.4455 13.7509 28.8772C10.7037 28.3088 7.9517 26.6913 5.97274 24.3055C3.99377 21.9197 2.91277 18.9162 2.91741 15.8164H0.703125C0.703125 18.882 1.61218 21.8788 3.31535 24.4277C5.01851 26.9767 7.43928 28.9634 10.2715 30.1365C13.1038 31.3097 16.2203 31.6166 19.227 31.0186C22.2337 30.4205 24.9956 28.9443 27.1633 26.7766C29.331 24.6088 30.8072 21.847 31.4053 18.8403C32.0034 15.8336 31.6964 12.7171 30.5233 9.88481C29.3501 7.05256 27.3634 4.63179 24.8145 2.92863C22.2655 1.22547 19.2687 0.316407 16.2031 0.316407Z"
        fill="url(#paint1_linear_1603_167)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1603_167"
          x1="16.202"
          y1="10.2812"
          x2="16.202"
          y2="22.4598"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B8BCB3" />
          <stop offset="1" stop-color="#FF9900" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1603_167"
          x1="16.2031"
          y1="0.316406"
          x2="16.2031"
          y2="31.3164"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B8BCB3" />
          <stop offset="1" stop-color="#FF9900" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const LongTimeAgo = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 30 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2328 28.7217C13.1875 28.7217 11.2684 28.3355 9.47544 27.563C7.68252 26.7895 6.11548 25.7327 4.77431 24.3927C3.43315 23.0526 2.3769 21.4855 1.60556 19.6915C0.832063 17.8986 0.445312 15.9795 0.445312 13.9342C0.445312 10.7708 1.35531 7.91949 3.17531 5.38016C4.99748 2.83866 7.39977 1.06741 10.3822 0.0664062C10.2706 2.60141 10.6595 5.03891 11.5489 7.37891C12.4373 9.71891 13.7806 11.7881 15.5789 13.5864C17.3773 15.3847 19.4464 16.7286 21.7864 17.618C24.1275 18.5074 26.5661 18.8964 29.1022 18.7848C28.1055 21.7672 26.3354 24.1689 23.7917 25.99C21.248 27.8111 18.3951 28.7217 15.2328 28.7217Z"
        fill="url(#paint0_linear_1613_41)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1613_41"
          x1="14.7738"
          y1="0.0664062"
          x2="14.7738"
          y2="28.7217"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E9D8D8" />
          <stop offset="1" stop-color="#D2B2B2" />
        </linearGradient>
      </defs>
    </svg>
  );
};
